<template lang="html">
  <div class="delete-site tier tier-three">
    <div class="tier-content">
      <Tooltip content="Here you can delete your website" />

      <Notification
        v-if="notification.active"
        :content="notification.content"
        :type="notification.type"
      />

      <h2>Delete your website</h2>

      <div class="helper-text">
        <p>
          You are about to delete your website,
          <strong>this cannot be undone.</strong>
        </p>
      </div>

      <hr />

      <Btn secondary :isLoading="btnDeleteLoading" @click="activateConfirm">
        Delete Site
      </Btn>

      <Confirm
        v-if="confirmActive"
        @confirm="startDeletion"
        @cancel="cancel"
        :message="deleteMessage"
        :link="{name: 'websites', params: {companyId: this.companyId}}"
      />
    </div>
  </div>
</template>

<script>
import page from '@/mixins/page'
import notification from '@/mixins/notification'

import {deleteCompanySiteData} from '@/lib/sites'
import {cancelSiteSubscriptionData} from '@/lib/payments/subscriptions'

import Btn from '@/components/Btn'
import Tooltip from '@/components/Tooltip'
import confirm from '@/mixins/confirm'

export default {
  name: 'delete-site',

  mixins: [page, confirm, notification],

  props: {
    siteId: String,
    companyId: String
  },

  components: {
    Btn,
    Tooltip
  },

  data() {
    return {
      site: {},
      btnDeleteLoading: false
    }
  },

  computed: {
    title() {
      return `You are about to delete your website!`
    },

    deleteMessage() {
      return `Are you sure you wish to delete your site? This is irreversible data cannot be recovered.`
    }
  },

  methods: {
    startDeletion() {
      this.btnDeleteLoading = true
      const whiteLabel = this.$store.state.whiteLabel

      if (whiteLabel) {
        this.deleteSite()
      } else {
        this.cancelSubscription()
      }
    },

    deleteSite() {
      deleteCompanySiteData(this.companyId, this.siteId).then(() => {
        this.confirmActive = false
        this.btnDeleteLoading = false

        this.triggerNotification('success', 'website', 'deleted')

        window.setTimeout(() => {
          this.$router.push({
            name: 'websites',
            params: {companyId: this.companyId}
          })
        }, this.closeDelay)
      })
    },

    cancelSubscription() {
      cancelSiteSubscriptionData(this.siteId).then(() => {
        this.deleteSite()
      })
    }
  }
}
</script>
